const WebState = {
    theme : 'light-mode',
    showLoadingView : false
}


export default WebState